import { render } from "./HelpPage.vue?vue&type=template&id=0bff2004"
import script from "./HelpPage.vue?vue&type=script&lang=js"
export * from "./HelpPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__